import { gql } from '@apollo/client'

export const CREATE_VOOH_AVAILABILITY_REPORT = gql`
  mutation createVoohAvailabilityReport(
    $brandId: ID
    $networkId: ID
    $asIds: [String!]
    $startMonth: ISO8601Date
    $endMonth: ISO8601Date
  ) {
    createVoohAvailabilityReport(
      input: {
        brandId: $brandId
        networkId: $networkId
        asIds: $asIds
        startMonth: $startMonth
        endMonth: $endMonth
      }
    ) {
      report {
        name
        status
        startDate
        endDate
        generatedAt
        csvUrl
      }
      success
      errors
    }
  }
`
